import { Component, OnInit, Input } from '@angular/core';
import { Config } from 'src/app/config/config';

@Component({
  selector: 'app-colors-table',
  templateUrl: './colors-table.component.html',
  styleUrls: ['./colors-table.component.scss']
})
export class ColorsTableComponent implements OnInit {
  @Input() tableData;
  @Input() options: any = {};
  constructor() { }
  ngOnInit() {
    // Config.logger(this.tableData);
  }

  /**
   * Rounding of value two decimal places
   */
  formatValue(value) {
    try {
      if (typeof value === 'number') {
        return parseFloat(value.toFixed(2));
      } else {
        return value;
      }
    } catch (error) {
      Config.logger(error);
    }
  }

}
